module.exports = __webpack_public_path__ + "static/media/id6-casa_moreira_v02.89a0068c.jpg";